// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3HRZ1","calendarButtons":"ClockData_calendarButtons__6kmR_"};